"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchTimeline = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _get = _interopRequireDefault(require("lodash/get"));

var _keyBy = _interopRequireDefault(require("lodash/keyBy"));

var _PulseUtil = _interopRequireDefault(require("../util/PulseUtil"));

var Constants = _interopRequireWildcard(require("../constants/Constants"));

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

var NotificationsSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _PulseApiHelper = _interopRequireDefault(require("./PulseApiHelper"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var fetchTimeline =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(store) {
    var params,
        timelineData,
        url,
        activeIMSOrg,
        locale,
        data,
        response,
        notifications,
        parsedNotifications,
        previousPageUrl,
        previousPageTimestamp,
        notificationsById,
        serverTimestamp,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            timelineData = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            url = new URL("".concat(_PulseApiHelper.default.getHostUrl(), "/ans/v2/notifications/timeline"));
            params['config_version'] = 0;
            activeIMSOrg = NotificationsSelectors.getActiveIMSOrg(store.getState());
            locale = _PulseUtil.default.getNotificationsLocaleMapper(NotificationsSelectors.getLocale(store.getState()));
            params[Constants.IMS_ORG_PARAM] = activeIMSOrg;
            params[Constants.LOCALE] = locale;
            url.search = String(new URLSearchParams(params));

            if (!(!timelineData || typeof timelineData === 'undefined' || Object.keys(timelineData).length === 0 && timelineData.constructor === Object)) {
              _context.next = 20;
              break;
            }

            _context.next = 12;
            return fetch(url.href, {
              method: 'GET',
              headers: _PulseApiHelper.default.getDefaultHeaders()
            });

          case 12:
            response = _context.sent;

            if (response.ok) {
              _context.next = 15;
              break;
            }

            throw new Error("TimelineService fetchTimeline failed, HTTP status ".concat(response.status));

          case 15:
            _context.next = 17;
            return response.json();

          case 17:
            data = _context.sent;
            _context.next = 21;
            break;

          case 20:
            data = timelineData;

          case 21:
            notifications = (0, _get.default)(data, 'notifications', []);
            parsedNotifications = [];
            notifications.forEach(function (notification) {
              var parsedNotification = _PulseApiHelper.default.createPulseMessageObject(notification);

              if (parsedNotification !== null) {
                parsedNotifications.push(parsedNotification);
              }
            });
            previousPageUrl = (0, _get.default)(data, 'paging').previous;
            previousPageTimestamp = params.to;

            if (previousPageUrl) {
              previousPageTimestamp = _PulseUtil.default.getQueryParamFromUrl(previousPageUrl, 'to');
            } //transform the array into an object with id as the key


            notificationsById = (0, _keyBy.default)(parsedNotifications, function (notification) {
              return notification.id;
            });
            _context.next = 30;
            return store.dispatch({
              type: types.NOTIFICATIONS_FETCHED,
              payload: {
                notificationsById: notificationsById,
                previousPageTimestamp: previousPageTimestamp
              }
            });

          case 30:
            serverTimestamp = (0, _get.default)(data, 'server-timestamp');
            _context.next = 33;
            return store.dispatch({
              type: types.LATEST_SERVER_TIMESTAMP_FETCHED,
              serverTimestamp: serverTimestamp
            });

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchTimeline(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchTimeline = fetchTimeline;
var _default = {
  fetchTimeline: fetchTimeline
};
exports.default = _default;